/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconCreditCardFilled/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconCreditCardFilled({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconCreditCardFilled",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconCreditCardFilled.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z1pgzMB': alignSelf,'--mt-2-Z1pgzMB': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1pgzMB': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1pgzMB': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1pgzMB': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1pgzMB': opacity,'--w-10-Z1pgzMB': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1pgzMB': typeof height === 'number' ? `${height}px` : height,'--a-7-Z1pgzMB': isAnimated ? animation : "none",'--sd-8-Z1pgzMB': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1pgzMB': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconCreditCardFilled.SvgPath"
  data-view-path={viewPath}
 d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
 style={{'--f-12-Z1pgzMB': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}